// extracted by mini-css-extract-plugin
export var textInput = "_ks-0";